module.exports = __webpack_public_path__ + "img/facebook.10d22af9.png";